/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ApiResponseOfVersionLog } from '../model';
/**
 * VersionLogApi - axios parameter creator
 * @export
 */
export const VersionLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionLog: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/versionLog`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * VersionLogApi - functional programming interface
 * @export
 */
export const VersionLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = VersionLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getVersionLog(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiResponseOfVersionLog>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getVersionLog(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * VersionLogApi - factory interface
 * @export
 */
export const VersionLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = VersionLogApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getVersionLog(options?: any): AxiosPromise<ApiResponseOfVersionLog> {
            return localVarFp.getVersionLog(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * VersionLogApi - interface
 * @export
 * @interface VersionLogApi
 */
export interface VersionLogApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionLogApiInterface
     */
    getVersionLog(options?: any): AxiosPromise<ApiResponseOfVersionLog>;

}

/**
 * VersionLogApi - object-oriented interface
 * @export
 * @class VersionLogApi
 * @extends {BaseAPI}
 */
export class VersionLogApi extends BaseAPI implements VersionLogApiInterface {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof VersionLogApi
     */
    public getVersionLog(options?: any) {
        return VersionLogApiFp(this.configuration).getVersionLog(options).then((request) => request(this.axios, this.basePath));
    }
}
